import "./styles/quasar.scss";
import iconSet from "quasar/icon-set/fontawesome-v6.js";
import Notify from 'quasar/src/plugins/Notify.js';;

// To be used on app.use(Quasar, { ... })
export default {
  plugins: { Notify },
  config: {
    notify: {
      progress: true,
      color: "purple",
      position: "top",
    },
  },
  iconSet: iconSet,
};
